// extracted by mini-css-extract-plugin
export default {"header":"mastProfileAndFoundationPanel_header__TF8sb","container":"mastProfileAndFoundationPanel_container__22kJe"};